import { useFetchAllVehicles } from '@@partner:graphql/query/vehicle/allVehicles.gql'
import { VehicleInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import React, { useRef } from 'react'
import { CheckPicker, PickerHandle, SelectPicker } from 'rsuite'


interface BaseProps {
  isMultiple: boolean
}

interface MultipleProps extends BaseProps {
  isMultiple: true
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
}

interface SingleProps extends BaseProps {
  isMultiple: false
  value: GQL_ID
  onChange: (value: GQL_ID) => void
}

type Props = MultipleProps | SingleProps

export default function SelectVehiclePicker ({ 
  value, 
  onChange,
  isMultiple 
}: Props) {
  const ref = useRef<PickerHandle>(null)
  const [ searchText, setSearchText ] = React.useState('')

  const { vehicles, loading, error } = useFetchAllVehicles({
    filter: {
      or: [
        {
          fields: [ 'license_plate' ],
          op: 'includes',
          value: searchText
        },
        {
          fields: [ 'id' ],
          op: 'contains',
          value: Array.isArray(value) ? value : [ value ]
        }
      ]
    },
    pager: {
      page: 1,
      limit: 20
    }
  })


  const { vehicles: selectedVehicles } = useFetchAllVehicles({
    filter: {
      fields: [ 'id' ],
      op: 'contains',
      value: Array.isArray(value) ? value : [ value ]
    },
    pager: {
      page: 1,
      limit: 20
    }
  })

  const mergedVehicles = [ ...(selectedVehicles || []), ...(vehicles || []) ].reduce((acc, vehicle) => {
    if (!acc.some(c => c.id === vehicle.id)) {
      const nameParts = [ vehicle.type?.name, vehicle.brand, vehicle.model, vehicle.license_plate ]
      const name = nameParts.filter(Boolean).join(' ')

      acc.push({ ...vehicle, name })
    }
    return acc
  }, [] as (VehicleInfo & { name: string })[])

  const handleSearch = (search: string) => {
    setSearchText(search)
  }
  
  if (isMultiple) {
    return (
      <CheckPicker
        ref={ref}
        value={value}
        data={mergedVehicles}
        onChange={onChange}
        searchable={true}
        onSearch={handleSearch}
        placeholder="Без транспорта"
        valueKey="id"
        labelKey="name"
      />
    )
  }

  return (
    <SelectPicker
      ref={ref}
      value={value}
      data={mergedVehicles}
      onChange={onChange}
      loading={loading}
      searchable={true}
      onSearch={handleSearch}
      placeholder="Без транспорта"
      valueKey="id"
      labelKey="name"
    />
  )
}